import type { TenantOrder } from '@/mocks/orders';
import { getOrderOutstandingDebt, isPickupHandoverOnConfirm } from '../components/pickupOrderConfirmation';

/** TCR-2264 — đơn nhận tại quầy còn nợ cần đồng ý ghi nhận công nợ; không đồng ý thì bỏ qua các đơn đó. */
export function splitConfirmTargets(orders: TenantOrder[], debtAcknowledged: boolean) {
  const debtOrders = orders.filter((order) => isPickupHandoverOnConfirm(order) && getOrderOutstandingDebt(order) > 0);
  const debtIds = new Set(debtOrders.map((order) => order._id));
  const skippedForDebt = debtAcknowledged ? [] : debtOrders;
  const toConfirm = debtAcknowledged ? orders : orders.filter((order) => !debtIds.has(order._id));
  const totalDebt = debtOrders.reduce((sum, order) => sum + getOrderOutstandingDebt(order), 0);
  return { toConfirm, skippedForDebt, debtOrders, totalDebt };
}
